export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";